<template>
  <div>
    <p class="subtitle-2 font-weight-medium mb-1" style="color: rgba(0,0,0,0.7)">Cálculo</p>

    <!-- Aviso semanal -->
    <div
      v-if="campanha.id_tipo_dado === 'C'"
      class="d-flex align-start pa-3 rounded mb-4"
      style="background: #fffde7; border: 1px solid #f9a825; gap: 10px"
    >
      <v-icon color="amber darken-2" small class="mt-1 flex-shrink-0">mdi-calendar-week</v-icon>
      <div>
        <p class="caption font-weight-bold ma-0 mb-1" style="color: #e65100">
          Campanha Semanal: meta replicada por semana
        </p>
        <p class="caption ma-0" style="color: #bf360c; line-height: 1.5">
          A meta abaixo será avaliada <strong>individualmente em cada semana</strong>
          <template v-if="arrayFechamentosSemanal.length > 0">
            ({{ arrayFechamentosSemanal.length }} semanas neste período)
          </template>. Um colaborador pode bater a meta na semana 1 e não bater na semana 2, o bônus é pago por cada semana atingida separadamente.
        </p>
      </div>
    </div>

    <SubEtapaCalculoChassi
      v-if="form.tipoConteudo === 2"
      :form="form"
    />
    <SubEtapaCalculoModelo
      v-else-if="form.tipoConteudo === 3"
      :form="form"
      :campanha="campanha"
    />
    <SubEtapaCalculoPeca
      v-else-if="form.tipoConteudo === 4"
      :form="form"
    />
    <SubEtapaCalculoServico
      v-else-if="form.tipoConteudo === 5"
      :form="form"
    />
    <SubEtapaCalculoIndicador
      v-else
      :form="form"
      :n-semanas="nSemanas"
    />
  </div>
</template>

<script>
import SubEtapaCalculoChassi    from "./calculo/SubEtapaCalculoChassi";
import SubEtapaCalculoModelo    from "./calculo/SubEtapaCalculoModelo";
import SubEtapaCalculoPeca      from "./calculo/SubEtapaCalculoPeca";
import SubEtapaCalculoServico   from "./calculo/SubEtapaCalculoServico";
import SubEtapaCalculoIndicador from "./calculo/SubEtapaCalculoIndicador";

export default {
  name: "ModalCadastroSubEtapaCalculo",

  components: {
    SubEtapaCalculoChassi,
    SubEtapaCalculoModelo,
    SubEtapaCalculoPeca,
    SubEtapaCalculoServico,
    SubEtapaCalculoIndicador
  },

  props: {
    form: { type: Object, required: true },
    campanha: { type: Object, default: () => ({}) },
    arrayFechamentosSemanal: { type: Array, default: () => [] }
  },

  computed: {
    nSemanas() {
      return this.campanha.id_tipo_dado === "C" && this.arrayFechamentosSemanal.length > 0
        ? this.arrayFechamentosSemanal.length
        : 1;
    }
  },

  watch: {
    "form.tipoCalculo"(val) {
      this.$set(this.form, "valorBonus", null);

      const newMetas = {};
      this.form.indicadoresSelecionados.forEach(ind => {
        newMetas[ind.id_indicador] = val === 2
          ? { faixas: [{ minimo: "", maximo: "", bonus: "" }, { minimo: "", maximo: "", bonus: "" }] }
          : { metaValor: "" };
      });
      this.$set(this.form, "metasIndicadores", newMetas);

      const newMetasModelos = {};
      this.form.modelosSelecionados.forEach(m => {
        const key = m.id_produto || m.id_peca || m.id_servico;
        newMetasModelos[key] = val === 2
          ? { faixas: [{ minimo: "", maximo: "", bonus: "" }, { minimo: "", maximo: "", bonus: "" }] }
          : { metaValor: "", valorBonus: "" };
      });
      this.$set(this.form, "metasModelos", newMetasModelos);
    }
  }
};
</script>
